import { StrictMode, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { App, initialScreen } from './App.tsx';
import { AppProvider, type Screen } from './lib/store.tsx';
import { initTelegram, inTelegram, startParam } from './lib/tg.ts';
import { takeLinkSession } from './lib/web.ts';
import { Landing } from './screens/landing.tsx';
import './styles.css';
import { autoTrackClicks, track, trackAppOpened } from './lib/events.ts';

initTelegram();
// Ссылка из письма (?k=…) — сессия клиента сайта на этом устройстве.
if (!inTelegram) takeLinkSession();
const initial = initialScreen(startParam(), location.search);

// В обычном браузере главная — витрина сайта, с неё заказ идёт прямо здесь, без Telegram.
// Сразу в приложение: ссылки на заказ, страница получателя, локальная разработка и ?app=1.
const q = new URLSearchParams(location.search);
const landingFirst = !inTelegram && initial.name === 'main' && location.hostname !== 'localhost' && !q.has('app');

autoTrackClicks();
if (landingFirst) track('site_visited', { utm: q.get('utm_source') ?? q.get('r') });
else trackAppOpened();

function Root() {
  const [screen, setScreen] = useState<Screen | null>(landingFirst ? null : initial);
  // Кнопка «назад» браузера с первого экрана приложения возвращает на витрину.
  useEffect(() => {
    if (!landingFirst) return;
    const onPop = () => {
      if (!new URLSearchParams(location.search).has('app')) setScreen(null);
    };
    addEventListener('popstate', onPop);
    return () => removeEventListener('popstate', onPop);
  }, []);
  if (!screen)
    return (
      <Landing
        onStart={(s) => {
          history.pushState(null, '', `${location.pathname}?app=1${location.search ? `&${location.search.slice(1)}` : ''}`);
          window.scrollTo(0, 0);
          setScreen(s);
        }}
      />
    );
  return (
    <AppProvider key={JSON.stringify(screen)} initial={screen}>
      <App />
    </AppProvider>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
